import { createRegistry } from "@repo/design-system/lib/client-registry";
import { controlsolutions } from "./controlsolutions";
import { eco2solar } from "./eco2solar";
import { econ } from "./econ";
import { eon } from "./eon";
import { eonGridsolutions } from "./eon-gridsolutions";
import { hungary } from "./hungary";
import { edgSub, edri } from "./mjp";
import { sverige } from "./sverige";
import { eonUk } from "./uk";

export const clientRegistry = createRegistry({
  eon,
  econ,
  "eon-gridsolutions": eonGridsolutions,
  uk: eonUk,
  controlsolutions,
  eco2solar,
  "edg-sub": edgSub,
  edri,
  hungary,
  sverige,
});
